module.exports = __webpack_public_path__ + "420eefa3842e897f63087f65fdb5b38f.jpg";